import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { t } from "../lib/i18n";
import Seo from "../components/Seo";
import { SectionHead, PersonCard, EmptyState, Loader } from "../components/Blocks";

const TYPES = ["all", "creator", "influencer", "photographer", "videographer", "filmmaker", "model", "talent", "ambassador", "member"];

export default function Creators() {
  const [items, setItems] = useState(null);
  const [type, setType] = useState("all");

  useEffect(() => {
    api
      .get("/public/creators", { params: type === "all" ? {} : { profile_type: type } })
      .then(({ data }) => setItems(data))
      .catch(() => setItems([]));
  }, [type]);

  return (
    <div data-testid="creators-page" className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <Seo
        title="Créateurs"
        description="Le réseau créatif Vytali : photographes, vidéastes, créateurs, influenceurs, mannequins et talents."
        path="/createurs"
        kind="creator"
      />
      <SectionHead as="h1" label="Réseau" title="Créateurs & Talents">
        Une identité de profil ne confère aucun privilège administratif. Les capacités sont multiples
        et non exclusives.
      </SectionHead>

      <div className="flex flex-wrap gap-3 mb-10" data-testid="creators-filters">
        {TYPES.map((tp) => (
          <button key={tp} className="vb-chip" data-active={type === tp} data-testid={`creators-filter-${tp}`} onClick={() => setType(tp)}>
            {tp === "all" ? "Tous" : t(`profile_types.${tp}`, tp)}
          </button>
        ))}
      </div>

      {items === null ? (
        <Loader />
      ) : items.length === 0 ? (
        <EmptyState message="Aucun profil publié pour ce filtre." testid="creators-empty" />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6" data-testid="creators-grid">
          {items.map((p, i) => (
            <PersonCard key={p.id} person={p} testid={`creator-card-${i}`} />
          ))}
        </div>
      )}
    </div>
  );
}
